import type { TokenStore } from "@/domains/tokens"

/**
 * Swap action mode for ETH↔WETH pair
 * When input is native and output is wrapped (or vice versa), use WETH contract directly
 * instead of routing through a swap aggregator
 */
export type SwapActionMode = "swap" | "wrap" | "unwrap"

/**
 * Determine the swap action mode based on input/output token pair
 * Returns "wrap" when converting ETH → WETH, "unwrap" when WETH → ETH
 */
export function getSwapActionMode(
  inputToken: TokenStore | undefined,
  outputToken: TokenStore | undefined,
  nativeToken: TokenStore,
  wrappedNativeToken: TokenStore,
): SwapActionMode {
  if (!inputToken || !outputToken) return "swap"

  const inputIsNative = inputToken.address.equalsString(nativeToken.address.toString())
  const inputIsWrapped = inputToken.address.equalsString(wrappedNativeToken.address.toString())
  const outputIsNative = outputToken.address.equalsString(nativeToken.address.toString())
  const outputIsWrapped = outputToken.address.equalsString(wrappedNativeToken.address.toString())

  if (inputIsNative && outputIsWrapped) return "wrap"
  if (inputIsWrapped && outputIsNative) return "unwrap"
  return "swap"
}
